import { Navbar } from "../Components/Navbar/Navbar.jsx";
import Banner from "../Components/Banner/Banner.jsx";

import Instructions from "../Components/InstructionsBanner/Instructions";
import GreenBanner from "../Components/GreenBanner/GreenBanner";
import { Footer } from "../Components/Footer/Footer";
import { Box, makeStyles } from "@material-ui/core";
import photo from "../Components/Banner/aboutBanner.png";
import CirclesBannerNosotros from "../Components/ThreeCirclesBanner/CirclesNosotros.jsx";
import style from "./AboutUs.module.css";
const useStyles = makeStyles(({ palette }) => ({
  about: {
    display: "grid",
    gridTemplateAreas: `
            "Navbar"
            "Banner"
            "CirclesBanner"
            "Instructions"
            "GreenBanner"
            "Footer" 
        `,
  },
}));

const AboutUs = () => {
  const classes = useStyles();

  const bannerSettings = {
    photo: `${photo}`,
    circleClassName: "fullCircle",
    smallCircle: "empty",
    smallCircleTitle: "",
    title: "Una experiencia única",
    paragraph:
      "Descubre una nueva manera de viajar en Taxi. Blanco Seguro transforma tu experiencia de una manera, segura, confiable y económica.",
    btnSettings: {
      variant: "contained",
      color: "primary",
      text: "Descarga la app",
    },
  };

  const circlesSettings = {
    view: "about",
    first: "Ponte en contacto con un conductor fácilmente por medio de la app",
    second:
      "Conductores certificados por el equipo de calidad de Blanco Seguro",
    third: "Precios accesibles para que viajes a donde quieras ",
  };

  const btnSettings = {
    variant: "outlined",
    color: "primary",
    text: "Descarga la app",
  };

  return (
    <Box component="div" className={style.conteiner}>
      <Navbar />
      <Banner bannerSettings={bannerSettings} />
      <CirclesBannerNosotros circlesSettings={circlesSettings} />
      <Instructions />
      <GreenBanner btn={btnSettings} />
      <Footer />
    </Box>
  );
};

export default AboutUs;
/*    */
